// subcollection tabs

var tabLinks = document.querySelectorAll(".tablinks");
var tabContent = document.querySelectorAll(".tabcontent");


tabLinks.forEach(function(el) {
   el.addEventListener("click", openTabs);
});


function openTabs(el) {
   var btnTarget = el.currentTarget;
   var country = btnTarget.dataset.country;
console.log(country)
   tabContent.forEach(function(el) {
      el.classList.remove("active");
   });

   tabLinks.forEach(function(el) {
      el.classList.remove("active");
   });

   document.querySelector("#" + country).classList.add("active");
   
   btnTarget.classList.add("active");
}


// Product Page JS
document.addEventListener("DOMContentLoaded", function() {
  const openButton = document.querySelector(".trigger");
  const closeButton = document.querySelector(".close-button");
  const modalWrapper = document.querySelector(".modal");
  const body = document.body;
  

  openButton.addEventListener("click", function(event) {
    modalWrapper.classList.add("show-modal");
    modalWrapper.style.opacity = 0; // Set initial opacity to 0 for fade-in effect
    modalWrapper.style.transition = "opacity 0.35s ease-in-out"; // Set transition for fade-in
    modalWrapper.offsetWidth = modalWrapper.offsetWidth; // Trigger reflow for smooth animation
    modalWrapper.style.opacity = 1; // Set final opacity to 1

    body.classList.add("popup-open");
    event.preventDefault();
  });

  closeButton.addEventListener("click", function(event) {
    modalWrapper.classList.remove("show-modal");
    modalWrapper.style.opacity = 1; // Set initial opacity to 1 for fade-out effect
    modalWrapper.style.transition = "opacity 0.35s ease-in-out";
    modalWrapper.offsetWidth = modalWrapper.offsetWidth; // Trigger reflow for smooth animation
    modalWrapper.style.opacity = 0; // Set final opacity to 0

    body.classList.remove("popup-open");
    event.preventDefault();
  });
});



  document.addEventListener("DOMContentLoaded", function() {
    const modalWrapper = document.querySelector(".modal");
    const body = document.body;

    // Function to check if the query parameter is present in the URL
    function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      const results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // Check if the query parameter is present and its value is true
    const contactPosted = getUrlParameter('contact_posted');
    if (contactPosted === 'true') {
      // Show the modal if contact_posted=true
      modalWrapper.classList.add("show-modal");
      body.classList.add("popup-open");
    }

    const closeButton = document.querySelector(".close-button");

    closeButton.addEventListener("click", function(event) {
      modalWrapper.classList.remove("show-modal");
      body.classList.remove("popup-open");
      event.preventDefault();
    });
  });




